import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import 'mapbox-gl/dist/mapbox-gl.css';
import { GoogleOAuthProvider, GoogleLogin, useGoogleLogin } from '@react-oauth/google';

const gtmId = process.env.REACT_APP_GTM_ID 
const optimizeId = process.env.REACT_APP_OPTIMIZE_ID

if(gtmId){
    // GTM script element in Head
    const gtmScript = document.createElement('script');
    gtmScript.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer', '${gtmId}');`
    document.head.appendChild(gtmScript);

    // GTM noscript element in Body
    const noscriptIframe = document.createElement('iframe');
    noscriptIframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
    noscriptIframe.height = '0';
    noscriptIframe.width = '0';
    noscriptIframe.style.display = 'none';
    noscriptIframe.style.visibility = 'hidden';

    const noscriptElement = document.createElement('noscript');
    noscriptElement.appendChild(noscriptIframe);
    document.body.appendChild(noscriptElement);
}

/* if(optimizeId){
    // Google Optimize script element in Head
    const optimizeScript = document.createElement('script');
    optimizeScript.src = `https://www.googleoptimize.com/optimize.js?id=${optimizeId}`
    document.head.appendChild(optimizeScript);
} */

const Root = () => (
    <GoogleOAuthProvider clientId={process.env.REACT_GOOGLE_CLIENT_ID}>
        <React.StrictMode>
            <App />
        </React.StrictMode>
    </GoogleOAuthProvider>
);
ReactDOM.render(<Root />, document.getElementById('app'));
